export default "__VITE_ASSET__6e00dd49__"